module.exports = __webpack_public_path__ + "img/compass.136c5a28.svg";